var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedCheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 34,
    viewBox: "0 0 44 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\xD0\xA0\xD0\xB5\xD0\xB6\xD0\xB8\xD0\xBC_\xD0\xB8\xD0\xB7\xD0\xBE\xD0\xBB\xD1\x8F\xD1\x86\xD0\xB8\xD0\xB8",
    clipPath: "url(#clip0_12_204)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M43.9997 2.21806C43.3324 2.78598 42.6862 3.32175 42.0401 3.85752C39.8581 5.70057 37.7397 7.5972 35.653 9.55812C32.6554 12.3763 29.7532 15.3123 26.9674 18.3662C23.2389 22.438 19.7223 26.7028 16.3964 31.1497C15.8986 31.814 15.3901 32.4677 14.8923 33.1213C14.7864 33.2606 14.6593 33.3571 14.5004 33.4321C13.8119 33.7428 13.1128 33.9785 12.3502 34C11.4286 34.0214 10.6025 33.7321 9.93514 33.0463C8.92889 32.0069 8.03914 30.8496 7.15999 29.7031C4.92503 26.8099 2.74304 23.8846 0.645784 20.8736C0.455124 20.6057 0.285649 20.3378 0.105582 20.0592C-0.0427091 19.8235 -0.0427092 19.8235 0.137358 19.6199C0.921181 18.7091 1.77915 17.8626 2.70067 17.1018C3.62219 16.3517 4.60727 15.7195 5.71945 15.3123C5.82537 15.2694 5.91011 15.2802 5.97366 15.3766C6.22787 15.7731 6.51386 16.1481 6.74689 16.5553C7.88026 18.5805 8.99244 20.6271 10.1364 22.6524C10.6342 23.531 11.185 24.3775 11.7252 25.2241C11.8206 25.3741 11.9371 25.5027 12.0536 25.6205C12.2125 25.7813 12.2972 25.7813 12.4667 25.6527C12.615 25.5348 12.7739 25.4062 12.8904 25.2562C13.6318 24.3775 14.3839 23.531 15.083 22.6202C17.964 18.9127 20.8133 15.1837 23.705 11.4869C26.459 7.97224 29.2447 4.47902 32.0199 0.985791C32.2635 0.675044 32.5071 0.375013 32.7507 0.0749811C32.8143 -0.0107422 32.8673 -0.032173 32.9732 0.0106886C34.6467 0.728621 36.3945 1.15724 38.174 1.51085C40.07 1.88589 41.9766 2.10019 43.8937 2.19663C43.9149 2.19663 43.9361 2.19663 43.9891 2.20735",
    fill: "#FE4B4E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_204"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCheck);
export default __webpack_public_path__ + "static/media/red_check.28cb1c7da522944c0ad5cece82a9f23e.svg";
export { ForwardRef as ReactComponent };